export default {
  email: {
    presence: { allowEmpty: false },
    email: true,
    length: {
      maximum: 64
    }
  },
  password: {
    presence: { allowEmpty: false },
    length: {
      maximum: 128
    }
  }
};
